import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PurpleColorTestPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <div className="w-full bg-white" data-id="element-4898" data-mp="32eeklc9v7gqk">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-4899" data-mp="32fzd6wcmcpls">
        <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-4900" data-mp="2yctd66g3nunr">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-4901" data-mp="2tjqddgkqboz4" />
          <span data-id="element-4902" data-mp="2olox13eou3rc">Go Back</span>
        </Link>
      </div>
      {/* Header with Purple Theme */}
      <header className="w-full bg-white py-4 px-6 md:px-12 border-b border-gray-100" data-id="element-4903" data-mp="2jndl8n4u1j6h">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-4904" data-mp="2eo0zy6tm0k60">
          <div className="flex items-center" data-id="element-4905" data-mp="2eq51ii41d734">
            <a href="/" className="no-underline" data-id="element-4906" data-mp="2am75iga0ccea">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rQktehvNa2Z7NATkWorM3j/Caveo_Update_Logo.png" alt="Caveo Logo" className="h-10 md:h-12" data-id="element-4907" data-mp="2aoju3ca9tl0b" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-6" data-id="element-4908" data-mp="av65r3lr3axu">
            <a href="/product" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-4909" data-mp="asa71d22wi8c">
              Product
            </a>
            <a href="/about-us" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-4910" data-mp="13jli1idhzf5h">
              About Us
            </a>
            <a href="/resources" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-4911" data-mp="uh2ip88x7knz">
              Resources
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-4912" data-mp="3f837k2tnxag8">
            <a href="/login" className="text-[#1A0933] no-underline hover:text-[#9966FF] px-4 py-2 rounded-md" data-id="element-4913" data-mp="3j9yb7dz2fzx6">
              Login
            </a>
            <a href="/signup" className="bg-[#3333CC] text-white px-4 py-2 rounded-md font-medium no-underline hover:bg-[#9966FF] transition-colors" data-id="element-4914" data-mp="1pt1zcxedxegz">
              Start Now
            </a>
          </div>
          <div className="md:hidden" data-id="element-4915" data-mp="1b19xno7ijyxq">
            <button onClick={toggleMenu} className="text-[#1A0933] focus:outline-none" data-id="element-4916" data-mp="1b08lthiob8ey">
              {isMenuOpen ? <XIcon size={24} data-id="element-4917" data-mp="1213mwa379d29" /> : <MenuIcon size={24} data-id="element-4918" data-mp="120llkz1ok8nh" />}
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden fixed inset-0 z-50 bg-white pt-20 px-6" data-id="element-4919" data-mp="x4d8dr71mpiy">
            <div className="flex flex-col space-y-4" data-id="element-4920" data-mp="s50dqk9xke5t">
              <a href="/product" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4921" data-mp="2rh30q4hrjqo8">
                Product
              </a>
              <a href="/about-us" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4922" data-mp="2uxz7hi6tk7kq">
                About Us
              </a>
              <a href="/resources" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4923" data-mp="33t56nybl3rea">
                Resources
              </a>
              <div className="pt-4 flex flex-col space-y-4" data-id="element-4924" data-mp="2g0gaxtnwgq2q">
                <a href="/login" className="text-[#1A0933] text-center py-2 border border-gray-200 rounded-md no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-4925" data-mp="2g31b8e8juxyd">
                  Login
                </a>
                <a href="/signup" className="bg-[#3333CC] text-white text-center py-2 rounded-md font-medium no-underline hover:bg-[#9966FF] transition-colors" onClick={toggleMenu} data-id="element-4926" data-mp="c6hj9tadcsy">
                  Start Now
                </a>
              </div>
            </div>
          </div>}
      </header>
      {/* Hero Section with Purple Theme */}
      <section className="w-full bg-[#1A0933] py-16 md:py-24" data-id="element-4927" data-mp="1i7oywafo5xgz">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4928" data-mp="1i65lcrlee0iw">
          <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-4929" data-mp="1x4g4j1fxs5f1">
            <div className="inline-block bg-[#9966FF] bg-opacity-20 text-[#9966FF] px-4 py-1 rounded-full text-sm font-medium mb-8" data-id="element-4930" data-mp="1s64pmcasb4py">
              <span className="flex items-center" data-id="element-4931" data-mp="25vztwwyop2xc">
                <span className="mr-2" data-id="element-4932" data-mp="21voatolyzanz">🚀</span>
                Launching the future of family cyber security
              </span>
            </div>
            <h1 className="mb-6 text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight" data-id="element-4933" data-mp="2fw8v6p7j9ejl">
              Protect your family from digital chaos
            </h1>
            <div className="mb-10 max-w-2xl mx-auto" data-id="element-4934" data-mp="2uhmqiq4fghyc">
              <p className="text-gray-300 text-lg" data-id="element-4935" data-mp="2ug37wsvatute">
                Take our free digital safety assessment to see where your
                <br data-id="element-4936" data-mp="2kk047iksto4c" />
                family's at risk and how you can fix it. No email required.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-12" data-id="element-4937" data-mp="2pi1p891sbxig">
              <Link to="/intro-assessment" className="bg-[#3333CC] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 no-underline hover:bg-[#9966FF]" data-id="element-4938" data-mp="2br4xekfonkcg">
                <span data-id="element-4939" data-mp="21v1yrok1i3u9">Start Now</span>
                <ArrowRightIcon size={18} data-id="element-4940" data-mp="26slbgk13a8k3" />
              </Link>
              <a href="/learn-more" className="border border-[#9966FF] text-[#9966FF] px-6 py-3 rounded-md font-medium no-underline hover:bg-[#9966FF] hover:bg-opacity-10 transition-colors" data-id="element-4941" data-mp="26t3eq0m65n1i">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Features Section with Purple Theme */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-4942" data-mp="3upktzyfknlpn">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4943" data-mp="3pqzz8ej39u8l">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A0933] mb-6" data-id="element-4944" data-mp="3prjc3gtvtsfr">
            Why people love Caveo
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mb-16" data-id="element-4945" data-mp="maj40fzzdhs0">
            Thousands of users trust Caveo to protect their aging parents
            online. Get the tools, skills, and confidence to keep your loved
            ones safe from digital threats.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12" data-id="element-4946" data-mp="ceg5rl8923ac">
            <div className="flex gap-6" data-id="element-4947" data-mp="8a8f3ii8ed9h">
              <div className="flex-shrink-0" data-id="element-4948" data-mp="2x2m4c7nare19">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4949" data-mp="2x3dnuk3mdlb6">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4950" data-mp="2szpebvvfgfna" />
                </div>
              </div>
              <div data-id="element-4951" data-mp="18gveepw0q795">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4952" data-mp="1ckjmrash56vg">
                  Quick and easy to follow:
                </h3>
                <p className="text-gray-700" data-id="element-4953" data-mp="1hile0j020ci0">
                  Learn how to protect your parents from scams in just 15
                  minutes a day—perfect for any family with seniors, regardless
                  of technical experience.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-4954" data-mp="1w7ho0llo7zl9">
              <div className="flex-shrink-0" data-id="element-4955" data-mp="1wan81mfg0ba4">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4956" data-mp="209w4x05s4p9w">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4957" data-mp="257xp5oexyumy" />
                </div>
              </div>
              <div data-id="element-4958" data-mp="5xo63bqc7o8u">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4959" data-mp="5yhdmex4ehs1">
                  Comprehensive protection:
                </h3>
                <p className="text-gray-700" data-id="element-4960" data-mp="2cryh9rvy4wkv">
                  From email scam detection to secure banking setup, we provide
                  all the tools needed to shield your parents from digital
                  fraud.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-4961" data-mp="2hjqbcceb9kfr">
              <div className="flex-shrink-0" data-id="element-4962" data-mp="2hkrkgbbrnwuu">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4963" data-mp="1ttvz9x1tfzwk">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4964" data-mp="1pssh33waprs6" />
                </div>
              </div>
              <div data-id="element-4965" data-mp="23sbo1tddex2w">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4966" data-mp="23sv04tgcar90">
                  Remote monitoring options:
                </h3>
                <p className="text-gray-700" data-id="element-4967" data-mp="3f78gzecoe6fj">
                  Our app allows you to help manage your parents' digital
                  security even when you can't be there in person.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-4968" data-mp="vzbemszewd06">
              <div className="flex-shrink-0" data-id="element-4969" data-mp="w2h78i791x0n">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4970" data-mp="10zpp0hohjz1d">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4971" data-mp="n0zrj0xr7xch" />
                </div>
              </div>
              <div data-id="element-4972" data-mp="rzb0l9g863tn">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4973" data-mp="s0voig81aoij">
                  Practical and actionable:
                </h3>
                <p className="text-gray-700" data-id="element-4974" data-mp="1jqgxzi4k9nf8">
                  Get clear, jargon-free guidance on how to secure devices,
                  recognize scams, and prevent fraud targeting seniors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section with Purple Theme */}
      <section className="w-full bg-[#9966FF] bg-opacity-10 py-16" data-id="element-4975" data-mp="1ylwuruwizxfb">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4976" data-mp="23ezny1xe54uz">
          <div className="text-center mb-12" data-id="element-4977" data-mp="2grzm48orcle0">
            <div className="flex justify-center space-x-2 mb-8" data-id="element-4978" data-mp="2gtaqa9m47v5n">
              <button className="w-3 h-3 rounded-full bg-[#3333CC]" data-id="element-4979" data-mp="2lrm1ano5cbpg"></button>
              <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-4980" data-mp="2loq0mrkwz8xb"></button>
              <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-4981" data-mp="27r1kfx1skpyl"></button>
            </div>
            <blockquote className="text-2xl md:text-3xl font-medium text-[#1A0933] max-w-4xl mx-auto" data-id="element-4982" data-mp="2br3995mfhowg">
              "After my mom nearly fell for a phishing scam, Caveo helped me set
              up proper protections that she could easily understand and use."
            </blockquote>
            <div className="mt-8" data-id="element-4983" data-mp="1o4n3uapmqzqi">
              <p className="text-[#1A0933] font-medium" data-id="element-4984" data-mp="1o1hc0npm9jr3">Michael Roberts</p>
              <p className="text-gray-500 text-sm" data-id="element-4985" data-mp="1t2ok6nvo8kya">
                Son of 72-year-old mother, Ohio
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section with Purple Theme */}
      <section className="w-full bg-[#1A0933] py-16 md:py-24" data-id="element-4986" data-mp="1k3jkhe8dilkj">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4987" data-mp="10ggqkx5g0wyl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-4988" data-mp="vhdjz89teioi">
            <div className="space-y-6" data-id="element-4989" data-mp="19gmze5q758rf">
              <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-4990" data-mp="19hoaga77pv95">
                Protect your aging parents from digital chaos today!
              </h2>
              <p className="text-lg text-gray-300" data-id="element-4991" data-mp="1jet04k09o8up">
                Take the first step toward safeguarding your parents from scams,
                fraud, and digital threats with our comprehensive protection
                tools.
              </p>
              <div className="pt-4" data-id="element-4992" data-mp="1t3azcwswe7w8">
                <Link to="/intro-assessment" className="bg-[#3333CC] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center sm:justify-start space-x-2 no-underline hover:bg-[#9966FF] inline-flex" data-id="element-4993" data-mp="1t6f7u6debpsp">
                  <span data-id="element-4994" data-mp="1x80sidw698dg">Start Now</span>
                  <ArrowRightIcon size={18} data-id="element-4995" data-mp="ut1kjyu31f23" />
                </Link>
              </div>
            </div>
            <div className="relative" data-id="element-4996" data-mp="zrmkry9c3yqj">
              <div className="bg-white p-4 rounded-lg shadow-xl overflow-hidden" data-id="element-4997" data-mp="zsnvg1mfuj7q">
                <img src="https://images.unsplash.com/photo-1591035897819-f4bdf739f446?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Family using digital devices safely" className="w-full h-auto rounded-md" data-id="element-4998" data-mp="13sevyx1rodpg" />
                <div className="absolute top-2 left-2 flex space-x-1" data-id="element-4999" data-mp="1ikgqs2ozcgim">
                  <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-5000" data-mp="1nhyr54oxlnf0"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-5001" data-mp="1rjbzpmjes4pm"></div>
                  <div className="w-3 h-3 bg-green-500 rounded-full" data-id="element-5002" data-mp="3p93gfu3e6bw6"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer with Purple Theme */}
      <footer className="w-full bg-white py-12 border-t border-gray-100" data-id="element-5003" data-mp="3lrfu2f14w7v1">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-5004" data-mp="3h0639b3umyhk">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-5005" data-mp="3gymnrmq0orgu">
            <div data-id="element-5006" data-mp="3c0bdjavt8ey3">
              <div className="text-2xl font-bold text-[#3333CC] mb-6" data-id="element-5007" data-mp="3c1w8h1m1dzwh">
                Caveo
              </div>
              <ul className="space-y-3" data-id="element-5008" data-mp="3812m4co8st5p">
                <li data-id="element-5009" data-mp="8ke4545h3b0t">
                  <a href="/" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-5010" data-mp="8kmf2qi1c69d">
                    Home
                  </a>
                </li>
                <li data-id="element-5011" data-mp="3vo0u0lyaqss0">
                  <a href="/resources" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-5012" data-mp="3vn91jjzzxb5y">
                    Resources
                  </a>
                </li>
                <li data-id="element-5013" data-mp="2fau029ql5olu">
                  <a href="/support" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-5014" data-mp="2faarhjmtsckh">
                    Support center
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-5015" data-mp="bup42k44nmq5">
              <div className="text-lg font-semibold text-[#1A0933] mb-6" data-id="element-5016" data-mp="3u73ofgyqs39g">
                Legal
              </div>
              <ul className="space-y-3" data-id="element-5017" data-mp="229kxjh3gs3o">
                <li data-id="element-5018" data-mp="23autkmdj8jt">
                  <a href="/privacy" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-5019" data-mp="psm09feo5r4a">
                    Privacy policy
                  </a>
                </li>
                <li data-id="element-5020" data-mp="gsqhopisatu8">
                  <a href="/terms" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-5021" data-mp="gr5rtd7ezz2p">
                    Terms and conditions
                  </a>
                </li>
                <li data-id="element-5022" data-mp="31kiwaeafzn4u">
                  <a href="/subscription" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-5023" data-mp="36hsizm6g5koz">
                    Subscription terms
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-5024" data-mp="2u0zyv30gbrcq">
              <div className="text-lg font-semibold text-[#1A0933] mb-6" data-id="element-5025" data-mp="37y6fos1m7fzb">
                Disclaimer
              </div>
              <p className="text-gray-600 text-sm" data-id="element-5026" data-mp="330d7xuknydwx">
                Caveo as a family protection platform does not monitor private
                communications. Please consult with your family before making
                any safety decisions. There is no bias towards or against any
                online platforms mentioned in this page.
              </p>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center" data-id="element-5027" data-mp="2k8kbtraasckz">
            <div className="mb-4 md:mb-0" data-id="element-5028" data-mp="1whyg8zhhckrv">
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" className="h-10 inline-block mr-4" data-id="element-5029" data-mp="1rk6frh2rrqc2" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="h-10 inline-block" data-id="element-5030" data-mp="f37emd359di" />
            </div>
            <div className="text-sm text-gray-500" data-id="element-5031" data-mp="9a9h3wfh8blb">
              © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>;
}